<template>
  <div class="header-phone">
    <div class="container">
      <p class="header-phone">
        <i v-if="linkType === 'tel:'" class="fa fa-phone"></i>
        <i v-else-if="linkType === 'mailto:'" class="fa fa-envelope"></i>
        <a :href="linkType + link">{{ link + (this.$userIsAdmin || linkType === 'mailto:' ? "" : " Support Hotline")}}</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    link () {
      if (this.$vlastMode && this.clientContactEmail) {
        return this.clientContactEmail
      }
      if (this.$userIsAdmin) {
        return this.vlastContactNumber
      }
      return this.contactNumber
    },
    linkType () {
      return this.link && this.link.includes('@') ? 'mailto:' : 'tel:'
    }
  }
}
</script>
